const STORAGE_KEYS = {
  LOGIN_AT: "loginAt",
} as const;

const storage = {
  setLoginAt: (date: Date) => {
    localStorage.setItem(STORAGE_KEYS.LOGIN_AT, String(date.getTime()));
  },
  getLoginAt: (): Date | null => {
    const value = localStorage.getItem(STORAGE_KEYS.LOGIN_AT);
    return value ? new Date(Number.parseInt(value, 10)) : null;
  },
  removeLoginAt: () => {
    localStorage.removeItem(STORAGE_KEYS.LOGIN_AT);
  },
  clearAll: () => {
    localStorage.clear();
  },
} as const;

export default storage;
